import { useState } from "react";
import { BtnComfirmSlipTranfersWidgetStyled } from "./styled";
import { MdAssignmentAdd } from "react-icons/md";
import { portalService } from "apiServices";
import { toast } from "react-toastify";
import { Displays } from "components";
import { AlertControl } from "components/Modals/Alert";

// label: ส่งมาเมื่ออยากให้เป็นปุ่มมีข้อความ (popup รายละเอียดการชำระเงิน) ไม่ส่ง = ไอคอนอย่างเดียว (ตาราง Transfer Slip)
const BtnComfirmSlipTranfersWidget = ({ _id, payment_id, label, onSuccess }) => {
  const [_isBgLoading, _setIsBgLoading] = useState(false);
  // const [_isShow, _setIsShow] = useState(false);

  const _handleClickModal = () => {
    // _setIsShow(true);
    AlertControl.show({
      title: "ยืนยันการรับทราบ",
      description: "คุณต้องการจะยืนยันการรับทราบใช่หรือไม่",
      btnLabel1: "ยกเลิก",
      btnLabel2: "ยืนยัน",
      onEvent2: async () => {
        _setIsBgLoading(true);
        let params = {
          payment_id: payment_id,
        };
        let res = await portalService.PATCH_ROOM_BOOKING_PAYMENT_ACTKNOWLEDGE(
          _id,
          params
        );
        if (res && res.status === 200) {
          _setIsBgLoading(false);
          toast.success("อัพเดตสำเร็จ");
          onSuccess && onSuccess();
        } else {
          _setIsBgLoading(false);
          toast.error("อัพเดตไม่สำเร็จ");
        }
      },
    });
  };
  // const _handleCloseModal = () => {
  //   _setIsShow(false);
  // };

  // const _handleConfirm = async () => {
  //   _setIsBgLoading(true);
  //   let res = await portalService.PUT_TRANSACTION_DETAIL(_id, {
  //     status: "2",
  //   });
  //   if (res && res.status === 200) {
  //     _setIsBgLoading(false);
  //     toast.success("ยืนยันสำเร็จ");
  //     onConfirmSuccess && onConfirmSuccess();
  //   } else {
  //     _setIsBgLoading(false);
  //     toast.error("ยืนยันไม่สำเร็จ");
  //   }
  // };

  return (
    <>
      <Displays.BGLoading visible={_isBgLoading} />
      <BtnComfirmSlipTranfersWidgetStyled
        className={label ? "with_label" : ""}
        onClick={_handleClickModal}
      >
        <MdAssignmentAdd size={label ? 18 : 22} color="#f89900" />
        {label && <span className="btn_label">{label}</span>}
      </BtnComfirmSlipTranfersWidgetStyled>
      {/* <Modals.BodyEmpty isShowModal={_isShow} onCloseModal={_handleCloseModal}>
        <PreRegisContainer>
          <div className="pre_regis_layout mb_1">
            {member_type === "2" && (
              <div className="pr_col">
                <div className="group_block">
                  <div className="gb_title">ผู้ปกครอง</div>
                  <div className="gb_content_list">
                    <div className="gb_item">
                      <Displays.LabelValue
                        label={"ชื่อ"}
                        value={guardian_first_name_th}
                      />
                    </div>
                    <div className="gb_item">
                      <Displays.LabelValue
                        label={"นามสกุล"}
                        value={guardian_last_name_th}
                      />
                    </div>
                    <div className="gb_item">
                      <Displays.LabelValue
                        label={"เบอร์โทรศัพท์"}
                        value={guardian_phone_number || "-"}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="pr_col">
              <div className="group_block">
                <div className="gb_title">นักเรียน</div>
                <div className="gb_content_list">
                  <div className="gb_item">
                    <Displays.LabelValue
                      label={"ชื่อ"}
                      value={student_first_name_th}
                    />
                  </div>
                  <div className="gb_item">
                    <Displays.LabelValue
                      label={"นามสกุล"}
                      value={student_last_name_th}
                    />
                  </div>
                  <div className="gb_item">
                    <Displays.LabelValue
                      label={"ชื่อเล่น"}
                      value={student_nickname_th || "-"}
                    />
                  </div>
                  <div className="gb_item">
                    <Displays.LabelValue
                      label={"เบอร์โทรศัพท์"}
                      value={
                        student_phone_number
                          ? student_phone_number !== "null"
                            ? student_phone_number
                            : "-"
                          : "-"
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="pre_regis_layout">
            <div className="pr_col">
              <div className="group_block">
                <div className="gb_title">ใบเสร็จ</div>
                <div className="gb_content_list">
                  <div className="gb_item">
                    <Displays.LabelValue
                      label={"สลิปโอน"}
                      value={
                        <a
                          href={`${IMG_PATH + slip_upload}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Link
                        </a>
                      }
                    />
                  </div>
                  <div className="gb_item">
                    <Displays.LabelValue
                      label={"วันที่สร้าง"}
                      value={moment(created_at).format("DD/MM/YY HH:mm")}
                    />
                  </div>
                  <div className="gb_item">
                    <Displays.LabelValue
                      label={"สถานะโอน"}
                      value={RENDER_TRANSFER_STATUS(transfer_status).label}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="pre_regis_action_layout">
            <div className="btn_wrap">
              <Buttons.BgStandard
                theme_gray
                label={"กลับ"}
                onClick={_handleCloseModal}
              />
            </div>
            {status === "1" && (
              <div className="btn_wrap">
                <Buttons.BgStandard label={"ยืนยัน"} onClick={_handleConfirm} />
              </div>
            )}
          </div>
        </PreRegisContainer>
      </Modals.BodyEmpty> */}
    </>
  );
};

export default BtnComfirmSlipTranfersWidget;
